import { render } from "./DetailTimeline.vue?vue&type=template&id=62b8bbdf&scoped=true"
import script from "./DetailTimeline.vue?vue&type=script&lang=js"
export * from "./DetailTimeline.vue?vue&type=script&lang=js"

import "./DetailTimeline.vue?vue&type=style&index=0&id=62b8bbdf&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62b8bbdf"]])

export default __exports__